module.exports = __webpack_public_path__ + "static/ts-logo-979021bd025f8864fd34be36333f0741.png";